import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/login/icon-left1.png';
import _imports_1 from '../../assets/image/login/icon-left2.png';
const _withScopeId = n => (_pushScopeId("data-v-55b71272"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-dialog-content flex"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("h1", null, "中国V链"), /*#__PURE__*/_createElementVNode("p", {
  class: "sub-title"
}, "全域数字资产交易及保护平台，真诚服务每一位创作者， 让创作更有价值"), /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", {
  class: "flex-align"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("p", null, "100万+正版视频素材，商用无忧")]), /*#__PURE__*/_createElementVNode("li", {
  class: "flex-align"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}), /*#__PURE__*/_createElementVNode("p", null, "区块链数字版权，为原创作品护航")]), /*#__PURE__*/_createElementVNode("li", {
  class: "flex-align"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}), /*#__PURE__*/_createElementVNode("p", null, "创意作品展示，共建灵感交流社区")]), /*#__PURE__*/_createElementVNode("li", {
  class: "flex-align"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}), /*#__PURE__*/_createElementVNode("p", null, "免费发布需求，高效沟通在线接单")])])], -1));
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "flex-align login-type"
};
const _hoisted_5 = {
  class: "wxlogin-qrcode"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "wxlogin-qrcode-canvas"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-align-between"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "num"
}, "1"), /*#__PURE__*/_createTextVNode(" 打开微信扫码 "), /*#__PURE__*/_createElementVNode("span", {
  class: "num"
}, "2"), /*#__PURE__*/_createTextVNode(" 关注微信公众号 "), /*#__PURE__*/_createElementVNode("span", {
  class: "num"
}, "3"), /*#__PURE__*/_createTextVNode(" 登录注册成功 ")], -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "sms-login-box"
};
const _hoisted_10 = {
  class: "error-tips fade-all"
};
const _hoisted_11 = {
  class: "input-box tel"
};
const _hoisted_12 = {
  class: "input-box sms"
};
const _hoisted_13 = {
  key: 0,
  class: "getsms"
};
const _hoisted_14 = {
  key: 1,
  class: "sms-login-box"
};
const _hoisted_15 = {
  class: "error-tips fade-all"
};
const _hoisted_16 = {
  class: "input-box tel"
};
const _hoisted_17 = {
  class: "input-box sms"
};
const _hoisted_18 = {
  class: "verify-tips fade-all"
};
const _hoisted_19 = {
  class: "verify-mobile"
};
const _hoisted_20 = {
  class: "input-box sms"
};
const _hoisted_21 = {
  key: 0,
  class: "getsms"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-warning"
}, [/*#__PURE__*/_createTextVNode(" 登录即表明同意 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/article/8",
  target: "_blank"
}, "服务协议"), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/article/13",
  target: "_blank"
}, "隐私条款")], -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-warning",
  style: {
    "color": "#f73759"
  }
}, [/*#__PURE__*/_createTextVNode(" 《用户服务协议》《作品上传及销售服务协议》均有更新，并于2023年3月21日起生效 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/article/49",
  target: "_blank"
}, "点击查看详情>>>"), /*#__PURE__*/_createTextVNode(" 您继续登录即表示您同意更新后的协议。 ")], -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "手机号绑定", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "绑定会让您的账号更加安全，防止账号丢失及方便找回", -1));
const _hoisted_26 = {
  class: "sms-login-box"
};
const _hoisted_27 = {
  class: "error-tips fade-all"
};
const _hoisted_28 = {
  class: "input-box tel"
};
const _hoisted_29 = {
  class: "input-box sms"
};
const _hoisted_30 = {
  key: 0,
  class: "getsms"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-login-dialog", {
      isMobile: $options.isMobile
    }])
  }, [_createVNode(_component_el_dialog, {
    modelValue: $data.showLoginDialog,
    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.showLoginDialog = $event),
    top: "15vh",
    "before-close": $options.handleClose,
    "show-close": $props.showClose,
    closeOnClickModal: $props.closeOnClickModal,
    closeOnPressEscape: $props.closeOnPressEscape,
    onClosed: $options.closed
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: _normalizeClass(["login-type-item fade-all", {
        active: $data.loginType == 2
      }]),
      onClick: _cache[0] || (_cache[0] = $event => $data.loginType = 2)
    }, "扫码登录", 2), _createElementVNode("div", {
      class: _normalizeClass(["login-type-item fade-all", {
        active: $data.loginType == 1
      }]),
      onClick: _cache[1] || (_cache[1] = $event => $data.loginType = 1)
    }, "密码登录", 2)]), _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_8, 512), [[_vShow, $data.loginType == 2]]), $data.loginType == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString($data.errorTips), 1), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      onKeyup: _cache[2] || (_cache[2] = _withKeys((...args) => $options.login && $options.login(...args), ["enter"])),
      onBlur: _cache[3] || (_cache[3] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      placeholder: "手机号码",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.phone = $event),
      maxlength: "11"
    }, null, 544), [[_vModelText, $data.form.phone, void 0, {
      trim: true
    }]])]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      onKeyup: _cache[5] || (_cache[5] = _withKeys((...args) => $options.login && $options.login(...args), ["enter"])),
      maxlength: "6",
      onBlur: _cache[6] || (_cache[6] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      placeholder: "输入验证码",
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.verificationCode = $event)
    }, null, 544), [[_vModelText, $data.form.verificationCode, void 0, {
      trim: true
    }]]), $data.countdown ? (_openBlock(), _createElementBlock("button", _hoisted_13, _toDisplayString($data.countdown + 's后重新获取'), 1)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "getsms",
      onClick: _cache[8] || (_cache[8] = (...args) => $options.sendSms && $options.sendSms(...args))
    }, "获取验证码"))])])) : _createCommentVNode("", true), $data.loginType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString($data.errorTips), 1), $data.loginStep == 'password' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      placeholder: "请输入用户名",
      onKeyup: _cache[9] || (_cache[9] = _withKeys((...args) => $options.login && $options.login(...args), ["enter"])),
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.pswForm.username = $event),
      maxlength: "100",
      onBlur: _cache[11] || (_cache[11] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args))
    }, null, 544), [[_vModelText, $data.pswForm.username, void 0, {
      trim: true
    }]])]), _createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      maxlength: "100",
      onKeyup: _cache[12] || (_cache[12] = _withKeys((...args) => $options.login && $options.login(...args), ["enter"])),
      placeholder: "请输入密码",
      type: "password",
      onBlur: _cache[13] || (_cache[13] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.pswForm.password = $event)
    }, null, 544), [[_vModelText, $data.pswForm.password, void 0, {
      trim: true
    }]])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("p", _hoisted_18, [_createTextVNode("验证码已发送至 "), _createElementVNode("span", _hoisted_19, _toDisplayString($data.loginMobile), 1), _createTextVNode("，请输入短信验证码完成登录")]), _createElementVNode("div", _hoisted_20, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      onKeyup: _cache[15] || (_cache[15] = _withKeys((...args) => $options.loginVerify && $options.loginVerify(...args), ["enter"])),
      maxlength: "6",
      onBlur: _cache[16] || (_cache[16] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      placeholder: "输入验证码",
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.verifyForm.code = $event)
    }, null, 544), [[_vModelText, $data.verifyForm.code, void 0, {
      trim: true
    }]]), $data.countdown ? (_openBlock(), _createElementBlock("button", _hoisted_21, _toDisplayString($data.countdown + 's后重新获取'), 1)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "getsms",
      onClick: _cache[18] || (_cache[18] = (...args) => $options.sendLoginCode && $options.sendLoginCode(...args))
    }, "重新获取"))]), _createElementVNode("p", {
      class: "back-step fade-all",
      onClick: _cache[19] || (_cache[19] = (...args) => $options.backToPswStep && $options.backToPswStep(...args))
    }, "返回重新输入账号密码")], 64))])) : _createCommentVNode("", true), $data.loginType != 2 ? (_openBlock(), _createElementBlock("button", {
      key: 2,
      class: "v-btn login-btn",
      onClick: _cache[20] || (_cache[20] = (...args) => $options.login && $options.login(...args))
    }, _toDisplayString($data.submiting ? '登录中...' : $data.loginType == 1 && $data.loginStep == 'verify' ? '确认登录' : '登录'), 1)) : _createCommentVNode("", true), _hoisted_22, _hoisted_23])])]),
    _: 1
  }, 8, ["modelValue", "before-close", "show-close", "closeOnClickModal", "closeOnPressEscape", "onClosed"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showBindDialog,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.showBindDialog = $event),
    width: "300px",
    top: "20vh",
    onClosed: $options.getWXUrl
  }, {
    default: _withCtx(() => [_hoisted_24, _hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("p", _hoisted_27, _toDisplayString($data.errorTips), 1), _createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      onKeyup: _cache[22] || (_cache[22] = _withKeys((...args) => $options.bindPhone && $options.bindPhone(...args), ["enter"])),
      onBlur: _cache[23] || (_cache[23] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      placeholder: "手机号码",
      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.bindForm.phone = $event),
      maxlength: "11"
    }, null, 544), [[_vModelText, $data.bindForm.phone, void 0, {
      trim: true
    }]])]), _createElementVNode("div", _hoisted_29, [_withDirectives(_createElementVNode("input", {
      class: "fade-all",
      onKeyup: _cache[25] || (_cache[25] = _withKeys((...args) => $options.bindPhone && $options.bindPhone(...args), ["enter"])),
      maxlength: "6",
      onBlur: _cache[26] || (_cache[26] = (...args) => $options.clearErrorTips && $options.clearErrorTips(...args)),
      placeholder: "输入验证码",
      "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.bindForm.verificationCode = $event)
    }, null, 544), [[_vModelText, $data.bindForm.verificationCode, void 0, {
      trim: true
    }]]), $data.countdown ? (_openBlock(), _createElementBlock("button", _hoisted_30, _toDisplayString($data.countdown + 's后重新获取'), 1)) : (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "getsms",
      onClick: _cache[28] || (_cache[28] = (...args) => $options.sendBindSms && $options.sendBindSms(...args))
    }, "获取验证码"))])]), _createVNode(_component_el_button, {
      type: "primary",
      style: {},
      onClick: $options.bindPhone
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.submiting ? '绑定中...' : '确定绑定'), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue", "onClosed"])], 2);
}